import React, { useState } from "react";
import JobApplicationProfileMatchResultHeader from "./JobApplicationProfileMatchResultHeader";
import { MatchResult } from "../../../../Entities/MatchResult";
import "./JobApplicationProfileMatchResult.scss";
import { Empty } from "antd";
import { UserProfile } from "../../../../Entities/UserProfile";
import JobApplicationProfileMatchResultDetails from "./JobApplicationProfileMatchResultDetails";
import { JobDescriptionEntity } from "../../../../Entities/JobDescription";

export type MatchFilterType = 'all' | 'matched' | 'partial' | 'unmatched';

interface JobApplicationProfileMatchResultProps {
  profileMatchResult: MatchResult | null;
  setIsResumeViewing: React.Dispatch<
    React.SetStateAction<{
      isResumeViewing: boolean;
      resumeUrl: string | null;
    }>
  >;
  userProfile: UserProfile | null;
  jobPost: JobDescriptionEntity;
}

const JobApplicationProfileMatchResult: React.FC<
  JobApplicationProfileMatchResultProps
> = ({ profileMatchResult, setIsResumeViewing, userProfile, jobPost }) => {
  const [activeFilter, setActiveFilter] = useState<MatchFilterType>('all');

  const handleFilterChange = (filter: MatchFilterType) => {
    setActiveFilter(filter);
  };

  return (
    <section className="job-application-profile-match-result-container">
      {profileMatchResult && (
        <JobApplicationProfileMatchResultHeader
          userProfile={userProfile}
          setIsResumeViewing={setIsResumeViewing}
          profileMatchResult={profileMatchResult}
          activeFilter={activeFilter}
          onFilterChange={handleFilterChange}
        />
      )}

      {profileMatchResult && (
        <div className="job-application-profile-match-result-details-container">
          <JobApplicationProfileMatchResultDetails
            jobPost={jobPost}
            profileMatchResult={profileMatchResult}
            activeFilter={activeFilter}
          />
        </div>
      )}

      {!profileMatchResult && (
        <div className="job-application-details-empty-placeholder-container">
          <Empty
            description="The user has not uploaded a resume yet."
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        </div>
      )}
    </section>
  );
};

export default JobApplicationProfileMatchResult;
